import RoutePlanner from "./routePlanner/index.js";

export function basicMapSetup(elementId, contextMenuItems = []) {
  const outdoorLayer = L.tileLayer(
    `https://api.mapy.cz/v1/maptiles/outdoor/256/{z}/{x}/{y}?apikey=${MAPY_CZ_API_KEY}`,
    {
      minZoom: 0,
      maxZoom: 19,
      attribution:
        '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
    }
  );

  const satelliteLayer = L.tileLayer(
    `https://api.mapy.cz/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey=${MAPY_CZ_API_KEY}`,
    {
      minZoom: 0,
      maxZoom: 19,
      attribution:
        '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
    }
  );

  const startpoint = getStartpointFromDomain();
  const map = L.map(elementId, {
    contextmenu: true,
    contextmenuWidth: 250,
    contextmenuItems: contextMenuItems,
    contextmenuInheritItems: false,
    layers: [outdoorLayer],
  }).setView(startpoint, 9);

  // We also require you to include our logo somewhere over the map.
  const LogoControl = L.Control.extend({
    options: {
      position: "bottomleft",
    },

    onAdd: function (map) {
      const container = L.DomUtil.create("div");
      const link = L.DomUtil.create("a", "", container);

      link.setAttribute("href", "http://mapy.cz/");
      link.setAttribute("target", "_blank");
      link.innerHTML = '<img src="https://api.mapy.cz/img/api/logo.svg" />';
      L.DomEvent.disableClickPropagation(link);

      return container;
    },
  });
  new LogoControl().addTo(map);

  const layerControl = L.control
    .layers({
      [I18n.t("js.map.layers.outdoor")]: outdoorLayer,
      [I18n.t("js.map.layers.satellite")]: satelliteLayer,
    })
    .addTo(map);
  return map;
}

export function setupMap(elementId) {
  let map = basicMapSetup(elementId, buildMenuOptions());

  const routePlanningMarkers = L.featureGroup();
  const routePlanningGeometry = L.featureGroup();

  routePlanningMarkers.addTo(map);
  routePlanningGeometry.addTo(map);

  map.on("contextmenu.show", (e) => {
    const latlng = e.latlng;
    const latLngEl =
      e.contextmenu._container.getElementsByClassName("showLatLng");

    if (latLngEl.length) {
      latLngEl[0].parentElement.innerHTML = `<span class="leaflet-contextmenu-icon showLatLng"></span>
      ${latlng.lat.toFixed(4)}N, ${latlng.lng.toFixed(4)}E`;
    }

    if (window.routePlanner.waypoints.length > 1) {
      e.contextmenu.setDisabled(7, false);
    } else e.contextmenu.setDisabled(7, true);
  });

  window.routePlanner = new RoutePlanner(
    routePlanningMarkers,
    routePlanningGeometry
  );

  $(`#${elementId}`).attr("data-map-loaded", true);

  if (
    //marker to add my position on the map
    $(`#${elementId}`).data("marker-lat") &&
    $(`#${elementId}`).data("marker-lon")
  ) {
    loadMarkers(map, {
      lat: $(`#${elementId}`).data("marker-lat"),
      lon: $(`#${elementId}`).data("marker-lon"),
    });
  } else {
    loadMarkers(map);
  }

  map.buildMenuOptions = buildMenuOptions;

  return map;

  function buildMenuOptions(coords) {
    return [
      {
        text: coords
          ? `${coords.lat.toFixed(4)}N, ${coords.lng.toFixed(4)}E`
          : "",
        iconCls: "showLatLng",
        callback: null,
        index: 0,
      },
      { separator: true, index: 1 },
      {
        text: `<i class="fa far fa-fw fa-arrow-from-left"></i> ${I18n.t(
          "js.map.context_menu.plan_route_from_here"
        )}`,
        callback: (e) => {
          window.routePlanner.addFromWaypoint(
            (e.relatedTarget && e.relatedTarget.getLatLng()) || e.latlng
          );
        },
        index: 2,
      },
      {
        text: `<i class="fa far fa-fw fa-arrow-to-right"></i> ${I18n.t(
          "js.map.context_menu.plan_route_to_here"
        )}`,
        callback: (e) => {
          window.routePlanner.addToWaypoint(
            (e.relatedTarget && e.relatedTarget.getLatLng()) || e.latlng
          );
        },
        index: 3,
      },
      {
        separator: true,
        index: 4,
      },
      {
        text: `<i class="far far fa-fw fa-eraser"></i> ${I18n.t(
          "js.map.context_menu.clear_route"
        )}`,
        callback: (e) => {},
        index: 7,
      },
      { separator: true, index: 8 },
      {
        text: `<i class="fa far fa-fw fa-search-plus"></i> ${I18n.t(
          "js.map.context_menu.zoom_in"
        )}`,
        callback: function (e) {
          map.flyTo(e.latlng, map.getZoom() + 1);
        },
        index: 9,
      },
      {
        text: `<i class="fa far fa-fw fa-search-minus"></i> ${I18n.t(
          "js.map.context_menu.zoom_out"
        )}`,
        callback: function (e) {
          map.zoomOut();
        },
        index: 10,
      },
    ];
  }
}

function loadMarkers(map, myPositionMarker = null) {
  //  markerLayer.removeAll();

  $.getJSON({
    url: `${
      document.location.pathname.slice(-1) === "/" //remove trailing / e.g. /atrakcie/
        ? document.location.pathname.slice(0, -1)
        : document.location.pathname
    }.json${document.location.search}`,
    //dataType: "json",
    //contentType: "application/json"
  }).done((data) => {
    const coords = [];

    data.attractions.forEach((m) => {
      if (m.id === data.location.selected_attraction_id) {
        let marker = createMarker(m, true);
        coords.push(marker.getLatLng());
        marker.addTo(map);
        marker.openPopup();
      } else {
        let marker = createMarker(m);
        coords.push(marker.getLatLng());
        marker.addTo(map);
      }
    });

    const defaultZoom = map.getBoundsZoom(
      map.getBounds(L.latLngBounds(coords))
    );

    let zoomValue;
    switch (data.location.class) {
      case "TourismRegion":
        zoomValue = defaultZoom + 1;
        break;
      case "Region":
        zoomValue = defaultZoom + 1;
        break;
      case "Attraction":
        zoomValue = 14;
        break;
      case "GpsLocation":
        zoomValue = 13;
        break;
      default:
        zoomValue = defaultZoom + 3;
    }

    if (data.location.center) {
      map.setView(
        [data.location.center.lat, data.location.center.lon],
        zoomValue
      );
    } else {
      map.fitBounds(L.latLngBounds(data.location.zoom_to_points).pad(-0.1));
    }

    if (myPositionMarker) {
      const coords = [myPositionMarker.lat, myPositionMarker.lon];
      const myLocationMarker = L.marker(coords, {
        icon: L.icon({
          iconUrl: "/images/markers/big_marker.svg",
          iconAnchor: [29.5, 57],
        }),
        zIndexOffset: 99999,
      });

      myLocationMarker.bindPopup(
        L.popup({
          content: I18n.t(`js.attractions.my_location`),
          offset: [0, -42],
        })
      );

      myLocationMarker.addTo(map).openPopup();
    }
  });
}

function createMarker(m, selected = false) {
  const coord = [m.gps.lat, m.gps.lon];

  const icon = L.icon({
    iconUrl: selected
      ? `/images/markers/big_marker.svg`
      : `/images/markers/${m.category_id}.png`,
    //shadowUrl: "leaf-shadow.png",

    //shadowSize: [50, 64], // size of the shadow
    iconAnchor: selected ? [29.5, 57] : [16, 35],
    //shadowAnchor: [4, 62], // the same for the shadow
    //popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
  });

  const marker = L.marker(coord, {
    icon: icon,
    zIndexOffset: selected ? 1000 : 0,
    contextmenu: true,
  });

  const isMobile = window.matchMedia(
    "only screen and (max-width: 576px)"
  ).matches;

  if (!isMobile) {
    marker.bindTooltip(m.name, { offset: [0, -20] });
  }

  const popup = L.popup({
    //lazload je hack aby sa nacitali obrazky az ked sa zobrazi popup.. este treba riesit event popupopen
    content: `<div class="marker-card ${selected ? "selected" : ""}">
      <a target="_blank" href="${m.url}">
        <img src="${m.thumbnail_url}" />
      </a>
      <div class="px-2 pt-2">
        <b><a target="_blank" href="${m.url}">
          ${
            selected
              ? m.name
              : `<a target="_blank" href="${m.url}">${m.name}</a>`
          }
        </a></b><br />
        ${m.category_name}<br />
        ${m.town_name}<br />
        <small>
          <a target="_blank" rel="noopener" href="https://maps.google.com/maps?daddr=${
            m.gps.lat
          },${m.gps.lon}">
            ${I18n.t(`js.attractions.gps_navigation`)}
          </a>
        </small>
      </div>
    </div>`,
    offset: [0, -42],
  });

  marker.bindPopup(popup);

  // if (selected) {
  //   //show card
  //   setTimeout(function () {
  //     marker.click();
  //   }, 500); //TODO toto je take pochybne.. na Iphone sa mapa nespravala dobre na Show obrazovke ak to bolo bez timeoutu vyriesit inak?
  // }

  return marker;
}

function getStartpointFromDomain() {
  const domain = ENV.tld; //window.location.hostname.slice(-2);
  let startpoint;
  switch (domain) {
    case "sk":
      startpoint = [48.807438, 19.597926];
      break;
    case "cz":
      startpoint = [49.802201, 15.568163];
      break;
    case "pl":
      startpoint = [52.325402, 19.141391];
      break;
    default:
      startpoint = [48.807438, 19.597926];
  }

  return startpoint;
}
